import { Spinner } from "@motleyhand/design"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(user)/(tenantBc)/dashboard")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Spinner />
}
